import { flare } from '@flareapp/js'
import { shouldReloadForChunkError } from '@/lib/chunk-reload'

/**
 * Browser error tracking via Flare (OBS-2). Env-gated like the server side:
 * without NEXT_PUBLIC_FLARE_KEY the client never lights up and report calls
 * no-op. Lighting the client auto-captures uncaught exceptions and unhandled
 * promise rejections.
 */
if (process.env.NEXT_PUBLIC_FLARE_KEY) {
  flare.light(process.env.NEXT_PUBLIC_FLARE_KEY)
  // sourcemapVersionId must match the version_id that
  // scripts/flare-upload-sourcemaps.mjs uploads under (constant by design —
  // chunk filenames are content-hashed, so no per-build version is needed).
  flare.configure({ stage: process.env.NODE_ENV, sourcemapVersionId: 'production' })
}

/**
 * Recover a tab that outlived a deploy. A page rendered from an older build can
 * lazily request a chunk the new build no longer serves; the import rejects as
 * a ChunkLoadError and the route dies. One reload pulls the current build.
 * Registered here so it also catches import failures that never reach a React
 * error boundary. `shouldReloadForChunkError` allows one reload per tab, so a
 * genuinely missing chunk cannot spin the page.
 */
const recoverFromChunkError = (value: unknown) => {
  if (shouldReloadForChunkError(value, window.sessionStorage)) window.location.reload()
}
window.addEventListener('unhandledrejection', (event) => recoverFromChunkError(event.reason))
window.addEventListener('error', (event) => recoverFromChunkError(event.error))
